var React = require('react');

function Cross20 (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"3","y1":"3","x2":"17","y2":"17","stroke":"black","strokeWidth":"1.5","strokeLinecap":"round","key":0}),React.createElement("line",{"x1":"17","y1":"3","x2":"3","y2":"17","stroke":"black","strokeWidth":"1.5","strokeLinecap":"round","key":1})]);
}

Cross20.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = Cross20;

Cross20.default = Cross20;
